<template>
  <v-container v-if="datosCargados">
    <v-btn
      v-show="esAdmin == 'true'"
      color="orange"
      dark
      elevation="5"
      @click="paginaUsuarios"
      class="ma-2 white--text"
      >Gestion Usuarios
    </v-btn>
    <v-row no-gutters class="hidden-md-and-up">
      <v-col cols="9" sm="9" md="9">
        <v-text-field
          v-model.lazy="buscar"
          append-icon="mdi-magnify"
          label="Buscar"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="3" sm="3" md="3">
        <v-btn color="orange" class="mt-3 ml-3" dark @click="obtenerDescargas">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-input class="hidden-sm-and-down">
      <v-text-field
        v-model.lazy="buscar"
        append-icon="mdi-magnify"
        label="Buscar"
        hide-details
      ></v-text-field>

      <v-btn color="orange" class="mt-3 ml-3" dark @click="obtenerDescargas">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-input>

    <v-sheet
      class="mx-auto hidden-sm-and-down"
      max-width="100%"
      style="padding-bottom: 2%"
      color="#FFFAF3"
    >
      <v-slide-group show-arrows>
        <v-slide-item
          v-for="n in this.carpetasPrimerNivel"
          :key="n"
          v-slot="{ active, toggle }"
        >
          <v-btn
            class="mx-2 white--text"
            :color="active ? 'blue' : 'orange'"
            depressed
            rounded
            dark
            @mousedown="toggle"
            @click="carpetaSeleccionadaConFiltro(n)"
          >
            {{ n }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>

    <v-select
      class="hidden-md-and-up"
      label="Filtrar por carpeta"
      v-model="carpetaSeleccionada"
      @change="carpetaSeleccionadaConFiltro(carpetaSeleccionada)"
      :items="carpetasPrimerNivel"
    ></v-select>

    <table id="tablaDescargas" cellspacing="20px">
      <tr>
        <th>Nombre</th>
        <th>Tamaño</th>
        <th
          @click="ordenarPorFecha()"
          @mouseover="eventoRatonPasandoPorEncima = true"
          @mouseleave="eventoRatonPasandoPorEncima = false"
        >
          <span
            :class="{
              claseCuandoPasaElRatoPorEncimaDeFecha:
                eventoRatonPasandoPorEncima,
            }"
            >Fecha</span
          >
          <v-icon
            v-if="ordenSeleccionado == 'asc'"
            class="ml-1"
            :class="{
              claseCuandoPasaElRatoPorEncimaDeFecha:
                eventoRatonPasandoPorEncima,
            }"
            dark
            small
            >mdi-sort-ascending</v-icon
          ><v-icon
            v-else-if="ordenSeleccionado == 'des'"
            class="ml-1"
            :class="{
              claseCuandoPasaElRatoPorEncimaDeFecha:
                eventoRatonPasandoPorEncima,
            }"
            dark
            small
            >mdi-sort-descending</v-icon
          >
        </th>
        <th>Acciones</th>
      </tr>
      <tr v-for="item in arrayDescargasFiltrado" :key="item.busqueda">
        <td class="carpeta" v-if="item.esCarpeta" colspan="4">
          <input
            :checked="item.archivoCheckeado"
            class="mr-2"
            type="checkbox"
            @click="carpetaSeleccionadaCheckBox(arrayDescargasFiltrado, item)"
          />{{ item.carpeta }}
        </td>
        <td v-else>
          <input
            style=""
            :checked="item.archivoCheckeado"
            class="mr-2"
            type="checkbox"
            @click="item.archivoCheckeado = !item.archivoCheckeado"
          />
          <span style="word-break: break-all">{{ item.nombreArchivo }}</span>
          <v-chip v-if="filtroEnUso">{{ item.carpeta }}</v-chip>
        </td>

        <td v-if="!item.esCarpeta" class="datosArchivo">{{ item.tamano }}</td>
        <td v-if="!item.esCarpeta" class="datosArchivo">{{ item.fecha }}</td>
        <td v-if="!item.esCarpeta" class="datosArchivo">
          <v-icon @click="descargarUnArchivo(item)"> mdi-download </v-icon>
          <v-icon v-if="compartir == 'true'" @click="compartirArchivo(item)">
            mdi-share-variant
          </v-icon>
        </td>
      </tr>
    </table>

    <v-card-text style="height: 100px; position: relative">
      <v-fab-transition>
        <v-btn
          v-show="archivosSeleccionado.length > 1"
          color="orange"
          dark
          fixed
          right
          bottom
          fab
          @click="descargarArchivosSeleccionados"
        >
          <v-badge color="green">
            <template v-slot:badge>
              <label>{{ archivosSeleccionado.length }}</label>
            </template>
            <v-icon>mdi-download</v-icon>
          </v-badge>
        </v-btn>
      </v-fab-transition>
      <dialogoCompartirArchivo ref="dialogoCompartirArchivo" />
    </v-card-text>

    <!-- DIALOGO PARA CUANDO DESCARGAS UN ELEMENTO O VARIOS -->
    <v-dialog v-model="visible" max-width="700" persistent>
      <v-card>
        <v-card-title
          class="orange lighten-2"
          transition="dialog-top-transition"
          >{{ tituloDescargaArchivo }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
          class="mt-6"
          v-if="archivosSeleccionado.length > 0 && archivosConjuntos"
        >
          <v-row
            v-for="archivo in this.archivosSeleccionado"
            :key="archivo.busqueda"
            class="ma-2"
          >
            <v-col cols="7">
              <span class="font-weight-black">{{
                archivo["nombreArchivo"]
              }}</span>
            </v-col>
            <v-col cols="3">
              <span class="ml-5">{{ archivo["tamano"] }}</span>
            </v-col>
            <v-col cols="2">
              <span class="ml-5 mr-2">
                <v-progress-circular
                  v-if="!archivo['descargado']"
                  indeterminate
                  color="orange"
                ></v-progress-circular>
                <v-icon color="green" v-else> mdi-check</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="mt-6" v-else>
          <v-row>
            <v-col cols="7">
              <span class="font-weight-black">{{
                archivoUnicoParaDescargar["nombreArchivo"]
              }}</span>
            </v-col>
            <v-col cols="3">
              <span class="ml-5">{{
                archivoUnicoParaDescargar["tamano"]
              }}</span>
            </v-col>
            <v-col>
              <span class="ml-5">
                <v-progress-circular
                  v-if="!archivoUnicoParaDescargar['descargado']"
                  indeterminate
                  color="orange"
                ></v-progress-circular>
                <v-icon color="green" v-else> mdi-check</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn
            v-if="todasLasDescargasRealizadas"
            color="black"
            text
            @click="visible = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
import dialogoCompartirArchivo from "./dialogoCompartirArchivo.vue";
import { DateTime } from "luxon";

export default {
  components: {
    dialogoCompartirArchivo,
  },
  data() {
    return {
      buscar: "",
      eventoRatonPasandoPorEncima: false,
      ordenSeleccionado: "nor",
      filtroEnUso: false,
      archivoUnicoParaDescargar: [],
      archivosConjuntos: false,
      visible: false,
      datosCargados: false,
      arrayArchivosDescargas: [],
      carpetasPrimerNivel: [],
      carpetaSeleccionada: "",
      carpetaSeleccionadaPorFiltro: "",
      esAdmin: localStorage.admin,
      compartir: "",
      tituloDescargaArchivo: "",
      todasLasDescargasRealizadas: false,
    };
  },
  computed: {
    arrayDescargasFiltrado() {
      if (this.buscar == "" && this.carpetaSeleccionadaPorFiltro == "") {
        return this.arrayArchivosDescargas;
      } else {
        let partesBusqueda = this.buscar.split(" ");
        return this.arrayArchivosDescargas.filter((archivo) => {
          let coincide =
            this.carpetaSeleccionadaPorFiltro == "" ||
            archivo.carpetaPrimerNivel.localeCompare(
              this.carpetaSeleccionadaPorFiltro
            ) == 0;

          if (coincide) {
            partesBusqueda.forEach((valorBusqueda) => {
              coincide =
                coincide &&
                archivo.busqueda
                  .toLowerCase()
                  .includes(valorBusqueda.toLowerCase());
            });
          }
          return coincide;
        });
      }
    },
    archivosSeleccionado() {
      return this.arrayArchivosDescargas.filter((e) => {
        return e.archivoCheckeado && !e.esCarpeta;
      });
    },
  },
  methods: {
    //Ordenamos por fecha
    ordenarPorFecha() {
      let arrayOrden = ["asc", "des", "nor"];

      if (this.ordenSeleccionado == "nor") {
        this.filtroEnUso = true;
        this.ordenSeleccionado = arrayOrden[0];

        //Eliminamos las carpetas
        let tipo = this.arrayArchivosDescargas.filter((archivo) => {
          if (!archivo.esCarpeta) {
            return true;
          }
        });

        ///Realizamos el orden
        tipo.sort((a, b) => {
          const nombreA = a.fechaOriginal;
          const nombreB = b.fechaOriginal;

          if (nombreA < nombreB) {
            return 1;
          }

          if (nombreA > nombreB) {
            return -1;
          }

          return 0;
        });

        this.arrayArchivosDescargas = tipo;
      } else if (this.ordenSeleccionado == "asc") {
        this.filtroEnUso = true;
        this.ordenSeleccionado = arrayOrden[1];

        //Eliminamos las carpetas
        let tipo = this.arrayArchivosDescargas.filter((archivo) => {
          if (!archivo.esCarpeta) {
            return true;
          }
        });

        ///Realizamos el orden
        tipo.sort((a, b) => {
          const nombreA = a.fechaOriginal;
          const nombreB = b.fechaOriginal;

          if (nombreA < nombreB) {
            return -1;
          }

          if (nombreA > nombreB) {
            return 1;
          }

          return 0;
        });

        this.arrayArchivosDescargas = tipo;
      } else if (this.ordenSeleccionado == "des") {
        this.filtroEnUso = false;
        this.ordenSeleccionado = arrayOrden[2];
        localStorage.hash = "";
        this.obtenerDescargas();
      }
    },
    //Obtenemos los datos de todas las descargas
    obtenerDescargas() {
      this.utilizandoFiltroFecha = false;
      if (!this.visible) {
        this.$estadoApp.cargando = true;
        this.filtroEnUso = false;
        this.ordenSeleccionado = "nor";

        if (!localStorage.hash) {
          this.arrayArchivosDescargas = [];
          this.carpetasPrimerNivel = [];
          localStorage.hash = "";
        }

        ApiZD.obtenerArchivosDescargas(localStorage.hash)
          .then((resultado) => {
            if (resultado.status === 204) {
            } else {
              localStorage.hash = resultado.data.hash;
              this.compartir = localStorage.compartir;
              this.crearArrayDescargas(Object.values(resultado.data.descargas));
            }
          })
          .catch((e) => {
            if (!localStorage.token) {
              this.$router.replace({ path: "/" }).catch(() => {});
            }
          })
          .finally(() => {
            this.datosCargados = true;
            this.$estadoApp.cargando = false;
          });
      }
    },

    paginaUsuarios() {
      this.$router.push({ path: "/principalUsuarios" });
    },

    //Descargamos un archivo mediante el icono de descargar
    descargarUnArchivo(elementoArrayDescargas) {
      this.archivosConjuntos = false;
      this.archivoUnicoParaDescargar = [];
      this.archivoUnicoParaDescargar = elementoArrayDescargas;

      this.tituloDescargaArchivo = "Descargando...";
      this.archivoUnicoParaDescargar.descargado = false;
      this.visible = true;
      ApiZD.descargarFichero(
        encodeURIComponent(elementoArrayDescargas.rutaCompleta)
      )
        .then((response) => {
          this.archivoUnicoParaDescargar.descargado = true;
          const blob = new Blob([response.data], { type: "octet/stream" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = elementoArrayDescargas.nombreArchivo;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((e) => {})
        .finally(() => {
          this.tituloDescargaArchivo = "Descarga finalizada";
          setTimeout(() => (this.visible = false), 2000);
        });
    },

    //Esta funcion se encarga de gestionar las carpetas seleccionadas mediante el checkbox
    carpetaSeleccionadaCheckBox(arrayArchivosDescargas, elementoArrayCarpeta) {
      elementoArrayCarpeta.archivoCheckeado =
        !elementoArrayCarpeta.archivoCheckeado;

      arrayArchivosDescargas.forEach((archivo) => {
        //Comprobamos solo los archivos que pertenezcan a la carpeta
        if (
          archivo["carpeta"] == elementoArrayCarpeta.carpeta &&
          !archivo.esCarpeta
        ) {
          archivo["archivoCheckeado"] = elementoArrayCarpeta.archivoCheckeado;
        }
      });
    },
    //Convertimos el tamaño en MB
    conversionBytes(bytes) {
      return (bytes / 1048576).toFixed(2) + " MB";
    },

    obtenerRutaArchivo(archivo) {
      return archivo.substring(0, archivo.lastIndexOf("\\"));
    },

    functionComparacionNombreArchivo(archivo1, archivo2) {
      return this.obtenerRutaArchivo(archivo1["nombre"]).localeCompare(
        this.obtenerRutaArchivo(archivo2["nombre"])
      );
    },

    //Creamos el array en el que incluimos las carpetas como titulo
    crearArrayDescargas(arrayDescargas) {
      let carpetaPrevia = null;

      this.arrayArchivosDescargas = [];
      //Ordenamos el array
      arrayDescargas.sort(this.functionComparacionNombreArchivo);

      // complementamos la informacion de los elementos del array
      arrayDescargas.forEach((archivo) => {
        var partesNombreArchivo = archivo["nombre"].split("\\");
        var carpeta = this.obtenerRutaArchivo(archivo["nombre"]);
        if (carpetaPrevia != carpeta) {
          //Aqui indicamos la informacion de la carpeta
          this.arrayArchivosDescargas.push({
            rutaCompleta: carpeta,
            nombreArchivo: "",
            descripcion: "",
            tamano: "",
            fecha: "",
            fechaOriginal: "",
            carpeta: carpeta,
            carpetaPrimerNivel: partesNombreArchivo[0],
            esCarpeta: true,
            archivoCheckeado: false,
          });
        }

        //añadimos la informacion del archivo
        this.arrayArchivosDescargas.push({
          rutaCompleta: archivo["nombre"],
          nombreArchivo: partesNombreArchivo[partesNombreArchivo.length - 1],
          descripcion: archivo["descripcion"],
          tamano: this.conversionBytes(archivo["tamano"]),
          fecha: this.obtenerLiteralFechaHora(archivo["fecha"]),
          fechaOriginal: archivo["fecha"],
          carpeta: carpeta,
          carpetaPrimerNivel: partesNombreArchivo[0],
          esCarpeta: false,
          archivoCheckeado: false,
          descargado: false,
        });

        carpetaPrevia = carpeta;
      });

      this.establecerPropiedadBusqueda(this.arrayArchivosDescargas);
      this.obtenerCarpetasPrimerNivel(this.arrayArchivosDescargas);
    },
    //Obtenemos la fecha en formato correcto
    obtenerLiteralFechaHora(fecha) {
      var fechaActual = DateTime.local(
        DateTime.local().year,
        DateTime.local().month,
        DateTime.local().day
      ).toISO();
      let diferenciaDias = DateTime.fromISO(fecha)
        .diff(DateTime.fromISO(fechaActual))
        .as("days");

      if (diferenciaDias > 0)
        return "Hoy, " + DateTime.fromISO(fecha).toFormat("HH:mm");
      else if (diferenciaDias < -0 && diferenciaDias > -1)
        return "Ayer, " + DateTime.fromISO(fecha).toFormat("HH:mm");
      else return DateTime.fromISO(fecha).toFormat("DD, HH:mm");
    },

    //Descargamos los archivos que selecciona el usuario
    descargarArchivosSeleccionados() {
      this.archivosConjuntos = true;
      this.visible = true;
      this.tituloDescargaArchivo =
        "Descargando " + this.archivosSeleccionado.length + " archivos....";
      this.todasLasDescargasRealizadas = false;
      let descargasRealizadas = 0;
      let errorDescarga = 0;
      this.archivosSeleccionado.forEach((e) => {
        e.descargado = false;
        ApiZD.descargarFichero(encodeURIComponent(e.rutaCompleta))
          .then((response) => {
            e.descargado = true;
            const blob = new Blob([response.data], { type: "octet/stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = e.nombreArchivo;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(() => {
            errorDescarga++;
          })
          .finally(() => {
            descargasRealizadas++;
            if (
              descargasRealizadas == this.archivosSeleccionado.length &&
              errorDescarga == 0
            ) {
              this.tituloDescargaArchivo = "Descargas realizadas correctamente";
              this.todasLasDescargasRealizadas = true;
            }
          });
      });
    },

    obtenerCarpetasPrimerNivel(arrayArchivos) {
      let carpetaPrevia = "";
      arrayArchivos.forEach((archivo) => {
        if (carpetaPrevia != archivo["carpetaPrimerNivel"]) {
          this.carpetasPrimerNivel.push(archivo["carpetaPrimerNivel"]);
        }
        carpetaPrevia = archivo["carpetaPrimerNivel"];
      });
    },
    //Establecemos la propiedad busqueda para poder usarla en los filtros
    establecerPropiedadBusqueda(arrayDescargas) {
      let archivosPorCarpeta = "";
      for (let i = arrayDescargas.length - 1; i >= 0; i--) {
        let e = arrayDescargas[i];
        if (e.esCarpeta) {
          e["busqueda"] = e["carpeta"] + " " + archivosPorCarpeta;
          archivosPorCarpeta = "";
        } else {
          e["busqueda"] = e["rutaCompleta"] + " " + e["descripcion"];
          archivosPorCarpeta += e["nombreArchivo"] + " " + e["descripcion"];
        }
      }
    },
    carpetaSeleccionadaConFiltro(valor) {
      if (valor == this.carpetaSeleccionadaPorFiltro) {
        this.carpetaSeleccionadaPorFiltro = "";
      } else {
        this.carpetaSeleccionadaPorFiltro = valor;
      }
    },

    //Boton para compartir un archivo con un correo especifico y tiempo indicado
    compartirArchivo(item) {
      this.$refs.dialogoCompartirArchivo.activarDialogo().then((resultado) => {
        if (!/.+@.+\..+/.test(resultado[0]) || resultado[1] == "") {
          this.$root.$dialogo.activarDialogo(
            "Fallo datos",
            "Rellena correctamente los datos para compartir el archivo",
            ["OK"]
          );
        } else {
          ApiZD.compartirArchivo(
            resultado[0],
            resultado[1],
            encodeURIComponent(item.rutaCompleta),
            DateTime.now().toISO()
          )
            .then((res) => {
              this.$root.$dialogo.activarDialogo(
                "Archivo compartido correctamente",
                "Se ha compartido el archivo correctamente",
                ["OK"]
              );
            })
            .catch((e) => {
              this.$root.$dialogo.activarDialogo(
                "Sin permiso",
                e.data.descripcion_error,
                ["OK"]
              );
            });
        }
      });
    },
    obtenerDescargasRetardo() {
      setTimeout(() => {
        this.obtenerDescargas();
      }, 500);
    },
  },
  created() {
    // Funcion que se ejecuta al abrir la pagina
    this.compartir = this.$estadoApp.compartir;
    localStorage.hash = "";
    this.obtenerDescargas();
  },
  mounted() {
    window.addEventListener("focus", this.obtenerDescargasRetardo);
  },
  destroyed() {
    window.removeEventListener("focus", this.obtenerDescargasRetardo);
  },
};
</script>

<style scoped>
#tablaDescargas {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tablaDescargas td,
#tablaDescargas th {
  border: 1px solid #ddd;
  padding: 5px;
  font-family: monospace;
  font-size: 80%;
}

.carpeta {
  /* font: bold 150% monospace; */
  background-color: rgb(237, 223, 170);
}

#tablaDescargas tr:nth-child(even) {
  background-color: #f2f2f2;
}

#tablaDescargas tr:hover {
  background-color: #ddd;
}

#tablaDescargas th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: orange;
  color: white;
}

.datosArchivo {
  text-align: center;
}

input[type="checkbox"] {
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.3); /* IE */
  -moz-transform: scale(1.3); /* FF */
  -webkit-transform: scale(1.3); /* Safari and Chrome */
  -o-transform: scale(1.3); /* Opera */
  transform: scale(1.3);
  padding: 10px;
}

.centrar_vertical {
  position: absolute;
  width: 100%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.pantalla_carga {
  position: absolute;
  width: 100%;
  height: 100%;
}
.fondo_pantalla_carga {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}

.claseCuandoPasaElRatoPorEncimaDeFecha {
  color: black;
  cursor: pointer;
}

@media screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0 0 1rem 0;
  }

  tr:nth-child(odd) {
    background: #ccc;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 0;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
}
</style>
